import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { GetUserMessagesOpts, MessageListResult } from '../interfaces/message';
import { Message } from '../models/message';
import { Institution } from '@models/institution';

@Injectable({
  providedIn: 'root'
})
export class MessageControllerService {
  private readonly baseUrl: string = environment.BASE_API_URL;

  constructor(private readonly http: HttpClient) {}

  public getUserMessages(
    opts: GetUserMessagesOpts
  ): Observable<MessageListResult> {
    if (
      opts.order_by &&
      opts.order_by !== 'created_at' &&
      opts.order_by !== '-created_at'
    ) {
      opts.order_by += ',-created_at';
    }
    if (!opts.page) {
      opts.page = 1;
    }
    let url = this.baseUrl + 'user/messages?page=' + opts.page;
    if (opts.search_phrase) {
      url += '&search_phrase=' + opts.search_phrase;
    }
    if (opts.business_entity) {
      url += '&business_entity=' + opts.business_entity;
    }

    return this.http.get(url) as Observable<MessageListResult>;
  }

  public getUnSeenCount(): Observable<number> {
    return this.http.get<number>(
      this.baseUrl + 'user/messages/get_unseen_count'
    );
  }

  public markMessageAsRead(message: Message) {
    return this.http.patch(`${this.baseUrl}user/messages/${message.id}`, {
      is_seen: true
    });
  }

  public deleteMessage(message: Message) {
    return this.http.delete(`${this.baseUrl}user/messages/${message.id}`);
  }

  public getTotalMessagesCount() {
    return this.http.get<number>(
      `${this.baseUrl}user/messages/get_total_count`
    );
  }

  public getAlerts(): Observable<Message[]> {
    return this.http.get<Message[]>(`${this.baseUrl}user/alerts`);
  }

  public getInstitutions(): Observable<Institution[]> {
    return this.http.get<Institution[]>(`${this.baseUrl}institutions`);
  }

  public deleteAlert(alert: Message) {
    return this.http.delete(`${this.baseUrl}user/alerts/${alert.id}`);
  }
}
